/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
} from './PaymentState';

/**
 * 
 * @export
 * @interface CompletedPaymentDtoV2
 */
export interface CompletedPaymentDtoV2 {
    /**
     * 
     * @type {string}
     * @memberof CompletedPaymentDtoV2
     */
    paymentReference: string;
    /**
     * 
     * @type {string}
     * @memberof CompletedPaymentDtoV2
     */
    bookingReference: string;
    /**
     * 
     * @type {PaymentState}
     * @memberof CompletedPaymentDtoV2
     */
    paymentState: PaymentState;
    /**
     * 
     * @type {string}
     * @memberof CompletedPaymentDtoV2
     */
    paymentMethodId: string;
    /**
     * 
     * @type {number}
     * @memberof CompletedPaymentDtoV2
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof CompletedPaymentDtoV2
     */
    refundedAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof CompletedPaymentDtoV2
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof CompletedPaymentDtoV2
     */
    deviceId: string;
}

/**
 * Check if a given object implements the CompletedPaymentDtoV2 interface.
 */
export function instanceOfCompletedPaymentDtoV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentReference" in value;
    isInstance = isInstance && "bookingReference" in value;
    isInstance = isInstance && "paymentState" in value;
    isInstance = isInstance && "paymentMethodId" in value;
    isInstance = isInstance && "deviceId" in value;

    return isInstance;
}

export function CompletedPaymentDtoV2FromJSON(json: any): CompletedPaymentDtoV2 {
    return CompletedPaymentDtoV2FromJSONTyped(json, false);
}

export function CompletedPaymentDtoV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletedPaymentDtoV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentReference': json['paymentReference'],
        'bookingReference': json['bookingReference'],
        'paymentState': PaymentStateFromJSON(json['paymentState']),
        'paymentMethodId': json['paymentMethodId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'refundedAmount': !exists(json, 'refundedAmount') ? undefined : json['refundedAmount'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'deviceId': json['deviceId'],
    };
}

export function CompletedPaymentDtoV2ToJSON(value?: CompletedPaymentDtoV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentReference': value.paymentReference,
        'bookingReference': value.bookingReference,
        'paymentState': PaymentStateToJSON(value.paymentState),
        'paymentMethodId': value.paymentMethodId,
        'amount': value.amount,
        'refundedAmount': value.refundedAmount,
        'created': value.created,
        'deviceId': value.deviceId,
    };
}

